import React from 'react';

import { Snackbar, Alert, AlertTitle, Slide, SlideProps } from '@mui/material';

interface StatusSnackbarProps {
  open: boolean;
  onClose: () => void;
  autoHideDuration?: number;
  title: string;
  message: string;
  variant?: 'success' | 'error' | 'warning' | 'info';
}

const SlideTransition = (props: SlideProps) => {
  return <Slide {...props} direction="down" />;
};

const StatusSnackbar: React.FC<StatusSnackbarProps> = ({
  open,
  onClose,
  autoHideDuration = 4000,
  title,
  message,
  variant = 'success',
}) => {
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={SlideTransition}
      sx={{
        '& .MuiSnackbarContent-root': {
          minWidth: 400,
          maxWidth: 800,
        },
      }}
    >
      <Alert
        onClose={handleClose}
        severity={variant}
        variant="filled"
        sx={{
          width: '80%',
          minWidth: 280,
          maxWidth: 800,
          '& .MuiAlert-message': {
            width: '100%',
            fontWeight: 'normal',
          },
          '& .MuiAlert-action': {
            alignItems: 'flex-start',
            paddingTop: '4px',
          },
          ...(variant === 'success' && {
            backgroundColor: '#DAFBED',
            '& .MuiAlertTitle-root': {
              color: '#053823',
              fontWeight: 'bold',
            },
            '& .MuiAlert-message': {
              color: '#053823',
              fontWeight: 'normal',
            },
          }),
        }}
      >
        <AlertTitle sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>{title}</AlertTitle>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default StatusSnackbar;
